/**
 * @generated SignedSource<<c9493ae298d11b4c0ac36d10a7dd8af9>>
 * @relayHash a33c82cf353a49d528cbc37291fbd2e5
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID c1ed16e46772bdb661b29d7c31a9fb46f9bc6c291689eef6cd0c0db4dee01f59

import type { ConcreteRequest, Query } from 'relay-runtime';
export type JsmProjectMenuContent_SidebarQuery$variables = {
  cloudId: string;
  projectKey: string;
};
export type JsmProjectMenuContent_SidebarQuery$data = {
  readonly jira_projectLevelSidebarMenuCustomization: {
    readonly __typename: "JiraProjectLevelSidebarMenuCustomization";
    readonly hiddenMenuItems: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly itemId: string;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | {
    readonly __typename: "QueryError";
    readonly __typename: "QueryError";
    readonly message: string | null | undefined;
  } | {
    // This will never be '%other', but we need some
    // value in case none of the concrete values match.
    readonly __typename: "%other";
  } | null | undefined;
};
export type JsmProjectMenuContent_SidebarQuery = {
  response: JsmProjectMenuContent_SidebarQuery$data;
  variables: JsmProjectMenuContent_SidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v2 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
      },
      {
        "kind": "Variable",
        "name": "projectKey",
        "variableName": "projectKey"
      }
    ],
    "kind": "LinkedField",
    "name": "jira_projectLevelSidebarMenuCustomization",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "__typename"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "concreteType": "JiraProjectLevelSidebarMenuItemConnection",
            "kind": "LinkedField",
            "name": "hiddenMenuItems",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraProjectLevelSidebarMenuItemEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraProjectLevelSidebarMenuItem",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "itemId"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ],
        "type": "JiraProjectLevelSidebarMenuCustomization"
      },
      {
        "kind": "InlineFragment",
        "selections": [
          {
            "kind": "ScalarField",
            "name": "message"
          }
        ],
        "type": "QueryError"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "JsmProjectMenuContent_SidebarQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "id": "c1ed16e46772bdb661b29d7c31a9fb46f9bc6c291689eef6cd0c0db4dee01f59",
    "metadata": {},
    "name": "JsmProjectMenuContent_SidebarQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f4aa95cb15002ab800202742b3e539cf";

export default node;
